export default __webpack_public_path__ + "static/media/orangearrow.39547815.svg";